"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fill: "#ED0006",
      d: "M12 15.044A4.386 4.386 0 0 1 9.246 16C6.9 16 5 14.21 5 12s1.901-4 4.246-4c1.05 0 2.013.36 2.754.956A4.386 4.386 0 0 1 14.754 8C17.1 8 19 9.79 19 12s-1.901 4-4.246 4c-1.05 0-2.013-.36-2.754-.956Z"
    }), (0, _jsxRuntime.jsx)("path", {
      fill: "#F9A000",
      d: "M12 15.044c.913-.733 1.492-1.825 1.492-3.044 0-1.22-.58-2.31-1.492-3.044A4.386 4.386 0 0 1 14.754 8C17.1 8 19 9.79 19 12s-1.9 4-4.246 4c-1.05 0-2.013-.36-2.754-.956Z"
    }), (0, _jsxRuntime.jsx)("path", {
      fill: "#FF5E00",
      d: "M12 15.044c.913-.733 1.492-1.825 1.492-3.044 0-1.22-.579-2.31-1.492-3.044-.913.733-1.492 1.825-1.492 3.044 0 1.22.58 2.31 1.492 3.044Z"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};